// extracted by mini-css-extract-plugin
export default {"root":"menu-button_root__Cohld","icon":"menu-button_icon__Tw1h4","open":"menu-button_open__og0Z0"};